module.exports = __webpack_public_path__ + "img/bg_avatar_male_34.ebf81fb6.png";